<form [formGroup]="form" autocomplete="off" class="form-horizontal">
    <div class="form-row">
        <label class="col-sm-4 col-form-label" for="zugezogenAm">
            {{ 'COMMON_UI.FRAGEBOGEN.BISHERIGEPERSOENLICHEVERHAELTNISSE.ZUGEZOGEN.ZUGEZOGENAM' | translate }}
        </label>
        <div class="col-sm-4">
            <date-picker
                    id="zugezogenAm"
                    messagePath="zugezogenAm"
                    formControlName="zugezogenAm"
                    [isRequired]=true>
            </date-picker>
        </div>
    </div>

    <common-ui-adresserfassung
            [(inlandsadresse)]="data.inlandsAdresse"
            [inlandOrtLocalzation]="getOrtLocalization"
            [(auslandsadresse)]="data.auslandsAdresse"
            [readonly]="readonly"
            disablePostfachadresse="true">
    </common-ui-adresserfassung>
</form>
